import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    waitingList_kindergartenVoucherQueueId: 'Номер ваучера',
    waitingList_numberInList: 'Номер в листе ожидания',
    waitingList_receiveDate: 'Дата и время',
    waitingList_childIin: 'ИИН ребенка',
    waitingList_childFullName: 'ФИО ребенка',
    waitingList_queuedType: 'Тип очереди',
    waitingList_status: 'Статус',
    waitingList_serviceProviderLocation: 'Населенный пункт',
    waitingList_serviceProviderBin: 'БИН',
    waitingList_userCategory: 'Возрастная группа',
    waitingList_arriveDeadline: 'Срок ваучера',
    waitingList_title: 'Лист ожидания',
    waitingList_modalTitle: 'Ваучер',
    waitingList_errorLoadTable: 'Не удалось загрузить лист ожидания'
  },
  kk: {
    waitingList_kindergartenVoucherQueueId: 'Ваучер нөмірі',
    waitingList_numberInList: 'Күту парағында кезегі',
    waitingList_receiveDate: 'Күні, уақыты',
    waitingList_childIin: 'Бала ЖСН-і',
    waitingList_childFullName: 'Баланың аты-жөні',
    waitingList_queuedType: 'Кезек түрі',
    waitingList_status: 'Мәртебесі',
    waitingList_userCategory: 'Жас тобы',
    waitingList_serviceProviderLocation: 'Аймақ',
    waitingList_serviceProviderBin: 'БИН',
    waitingList_arriveDeadline: 'Ваучер мерзімі',
    waitingList_title: 'Күту парағы',
    waitingList_modalTitle: 'Ваучер',
    waitingList_errorLoadTable: 'Күту парағын жүктеу мүмкін болмады'


  }
});
